// extracted by mini-css-extract-plugin
module.exports = {"book":"Book_book__19B4S","cover":"Book_cover__Y10hF","content":"Book_content__2wn5Y","list":"Book_list__2hI9R"};